var interval = {
  gaodunInterval: function (callback, delay) {
    if (window.requestAnimationFrame) {
      // 生成并记录定时器ID
      var obj_1 = window.interValPrecisionObj || (window.interValPrecisionObj = {
        num: 0
      });
      obj_1.num++;
      obj_1['n' + obj_1.num] = true;
      var intervalId_1 = obj_1.num;
      // 开始时间
      var startTime_1 = +new Date();
      // 已执行次数
      var count_1 = 0;
      // 延迟时间
      delay = delay || 0;
      (function loop() {
        // 定时器被清除，则终止
        if (!obj_1['n' + intervalId_1]) return;
        // 满足条件执行回调
        if (+new Date() > startTime_1 + delay * (count_1 + 1)) {
          count_1++;
          callback(count_1);
        }
        requestAnimationFrame(loop);
      })();
      return intervalId_1;
    } else {
      var id = window.setInterval(function () {
        callback();
      }, delay);
      return id;
    }
  },
  gaodunClearInterval: function (intervalId) {
    if (window.cancelAnimationFrame) {
      if (window.interValPrecisionObj) {
        delete window.interValPrecisionObj['n' + intervalId];
      }
    } else {
      clearInterval(intervalId);
    }
  }
};
export default interval;